import GPTIcon from './GPT';
import GPTLoading from './GPTLoading';
import MermaidIcon from './Mermaid';
import MonoIcon from './Mono';
import TabsIcon from './Tabs';

export {MermaidIcon, MonoIcon, TabsIcon, GPTIcon, GPTLoading};

export {
    ArrowUturnCcwLeft as UndoIcon,
    ArrowUturnCwRight as RedoIcon,
    //
    Bold as BoldIcon,
    Italic as ItalicIcon,
    Underline as UnderlineIcon,
    Strikethrough as StrikethroughIcon,
    FontCursor as MarkIcon,
    //
    Text as TextIcon,
    Heading as HeadingIcon,
    Heading1 as Heading1Icon,
    Heading2 as Heading2Icon,
    Heading3 as Heading3Icon,
    Heading4 as Heading4Icon,
    Heading5 as Heading5Icon,
    Heading6 as Heading6Icon,
    //
    ListUl as ListBlIcon,
    ListOl as ListOlIcon,
    //
    TextOutdent as LiftIcon,
    TextIndent as SinkIcon,
    //
    Font as TextColorIcon,
    //
    Link as LinkIcon,
    QuoteClose as QuoteIcon,
    Scissors as CutIcon,
    Sticker as NoteIcon,
    Paperclip as FileIcon,
    Minus as HRuleIcon,
    //
    LayoutList as TableIcon,
    //
    ChevronsExpandHorizontal as IframeIcon,
    SquareCheck as CheckListIcon,
    Picture as ImageIcon,
    Person as UserIcon,
    FaceSmile as EmojiIcon,
    //
    Code as CodeInlineIcon,
    FileCode as CodeBlockIcon,
    //
    Function as FunctionInlineIcon,
    CurlyBracketsFunction as FunctionBlockIcon,
    //
    Hashtag as AnchorIcon,
    SquareDashedText as BlockIcon,
    LayoutColumns3 as LayoutIcon,
    //
    Pencil as DrawIoIcon,
    FolderCode as HtmlBlockIcon,
    ArrowChevronRight as FoldingHeadingIcon,
} from '@gravity-ui/icons';
